"use client";

import { useEffect } from "react";
import { initializeApp } from "@/state/store";
import { usePathname, useRouter } from "next/navigation";

const time = 9 * 60 * 1000;

const restricted_routes = [
  "/",
  "/contact-us",
  "/all-pitches",
  "/about-you",
  "/role-selection",
  "/about-company",
  "/seller-industry",
  "/seller/selling-info",
  "/business-model",
  "/customer/selling-to",
  "/b2c/ideal-customer",
  "/b2c/buyer-persona",
  "/other-info",
  "/difficulty-level",
  "/customer/industry",
  "/b2c/motivates",
  "/recording",
];

const AppInitializer = () => {
  const router = useRouter();
  const pathName = usePathname();

  const checkAndRedirect = async () => {
    const result = await initializeApp();
    if (
      result.isError &&
      (restricted_routes.includes(pathName) || pathName.includes("/feedback"))
    ) {
      localStorage.clear();
      return "/sign-in";
    } else {
      return pathName;
    }
  };
  useEffect(() => {
    const interval = setInterval(async () => {
      const redirectPath = await checkAndRedirect();
      if (redirectPath && redirectPath !== pathName) {
        router.push(redirectPath);
      }
    }, time);
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default AppInitializer;
